<template>
  <path d="M2 2.965a1 1 0 0 1 1.577-.817l7.133 5.035a1 1 0 0 1 0 1.634l-7.133 5.035A1 1 0 0 1 2 13.035V2.965z" />
  <path d="M14 2.75a.75.75 0 0 0-1.5 0v10.5a.75.75 0 0 0 1.5 0V2.75z" />
</template>
